<template>
  <div
    class="modal fade"
    id="generate-vouchers"
    tabindex="-1"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            id="generate-vouchers-close"
          ></button>
          <div class="text-center">
            <h4 class="mb-8">{{ $t("vouchers_batches.generate_vouchers") }}</h4>
          </div>
          <div class="row g-6">
            <div class="col-sm-6">
              <label class="form-label" for="">{{
                $t("vouchers_batches.name")
              }}</label>
              <input
                v-model="voucher_batch.name"
                @input="validate"
                :class="{ 'is-invalid': errors.name }"
                type="text"
                class="form-control"
              />
            </div>
            <div class="col-sm-6">
              <label class="form-label" for="">{{
                $t("vouchers_batches.vouchers_count")
              }}</label>
              <div class="input-group">
                <span class="input-group-text">
                  <i class="ti ti-ticket"></i>
                </span>
                <input
                  v-model="voucher_batch.quantity"
                  @input="validate"
                  :class="{ 'is-invalid': errors.quantity }"
                  type="number"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-sm-6">
              <label class="form-label" for="">{{
                $t("vouchers_batches.voucher_value")
              }}</label>
              <div class="input-group">
                <span class="input-group-text">
                  {{ settings.currency }}
                </span>
                <input
                  v-model="voucher_batch.voucher_value"
                  @input="validate"
                  :class="{ 'is-invalid': errors.voucher_value }"
                  type="number"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-sm-6">
              <label class="form-label" for="">{{
                $t("vouchers_batches.valid_before")
              }}</label>
              <div class="input-group">
                <span class="input-group-text">
                  <input
                    class="form-check-input mt-0"
                    type="checkbox"
                    v-model="voucher_batch.valid_before_enabled"
                  />
                </span>
                <input
                  v-model="voucher_batch.valid_before"
                  @input="validate"
                  :disabled="!voucher_batch.valid_before_enabled"
                  :class="{ 'is-invalid': errors.valid_before }"
                  type="date"
                  class="form-control"
                />
              </div>
            </div>

            <div class="text-danger">
              <div v-if="errors.server_error">{{ errors.server_error }}</div>
            </div>
            <div class="col-12 d-flex justify-content-end">
              <button
                class="btn btn-success"
                :disabled="!validated || loading"
                @click.prevent="store"
              >
                {{ $t("batches.add") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters, mapState } from "vuex";
export default {
  name: "VouchersGenerate",
  computed: {
    ...mapGetters(["user", "settings"]),
  },
  data() {
    return {
      error: "",
      message: "",
      voucher_batch: {
        name: "",
        valid_before: null,
        voucher_value: 1,
        quantity: 1,
        valid_before_enabled: false,
      },
      errors: {
        name: null,
        quantity: null,
        voucher_value: null,
        quantity: null,
        server_error: null,
        money: null,
      },
      loading: false,
      validated: false,
    };
  },
  async created() {
    this.loading = false;
  },
  methods: {
    async store() {
      this.loading = true;
      if (
        !this.voucher_batch.valid_before_enabled &&
        this.voucher_batch.valid_before != null
      ) {
        this.voucher_batch.valid_before = null;
      }
      const response = await axios.post(
        "/vouchers/generate",
        this.voucher_batch,
      );
      if (response.status == 200) {
        this.loading = false;
        document.getElementById("generate-vouchers-close").click();
        this.$notify({
          text: this.$t(
            "vouchers_batches.vouchers_batch_generated_successfully",
          ),
          type: "success",
        });
        this.$emit("updated");
      } else if (response.status == 210) {
        this.loading = false;
        if (response.data.error == "batch_name_already_exists") {
          this.errors.server_error = this.$t(
            "vouchers_batches.batch_name_already_exists",
          );
          this.validated = false;
        } else {
          this.errors.server_error = response.data.error;
          this.validated = false;
        }
      } else {
        this.errors.server_error = this.$t(
          "vouchers_batches.failed_to_generate",
        );
        this.validated = false;
        this.$notify({
          text: this.$t("vouchers_batches.failed_to_generate"),
          type: "error",
        });
      }
    },
    validate() {
      this.validated = true;
      this.errors.name = null;
      this.errors.quantity = null;
      this.errors.voucher_value = null;
      this.errors.server_error = null;
      this.errors.money = null;

      if (this.voucher_batch.name == "") {
        this.validated = false;
        this.errors.name = this.$t("errors.vouchers_batches.name_empty");
      }
      if (this.voucher_batch.quantity < 1) {
        this.validated = false;
        this.errors.quantity = this.$t(
          "errors.vouchers_batches.cannot_be_less_than_1",
        );
      }
      if (this.voucher_batch.voucher_value < 1) {
        this.validated = false;
        this.errors.quantity = this.$t(
          "errors.vouchers_batches.cannot_be_less_than_1",
        );
      }
      if (
        this.user.money -
          this.voucher_batch.quantity * this.voucher_batch.voucher_value <
          0 &&
        this.user.type == "reseller"
      ) {
        this.validated = false;
        this.errors.money =
          this.$t(
            "errors.vouchers_batches.money_not_enough_to_complete_the_operation_required",
          ) +
          " " +
          this.voucher_batch.quantity * this.voucher_batch.voucher_value;
      }
    },
  },
};
</script>
